import { fm } from 'Components/FormatMessage';
import { TESSearchField, TESSearchFields } from '../definitions';
import { TParkinsonESSearchFields } from '../definitions/parkinson';
import { diagnosesByPlatform } from '../functions/constants/diagnoses';

export const parkinsonExtendedSearchFields = (searchFields?: TESSearchFields): TESSearchField[] => [
  {
    name: 'gender',
    type: 'Radio',
    options: ['male', 'female'],
  },
  {
    name: 'age',
    type: 'RangeSlider',
    min: 0,
    max: 100,
    showRangeText: true,
    marks: [{ value: 33 }, { value: 66 }],
  },
  {
    name: 'diagnosis',
    type: 'MultiSelect',
    options: diagnosesByPlatform.parkinson,
    optionFormatter: (name: string | number): string | React.JSX.Element => {
      if (name === 'alzheimerSuspicion') {
        return fm('diagnosis.opts.alzheimerSuspicion');
      }
      return `${name}`;
    },
    tooltips: [
      { index: 0, message: fm('diagnosis.parkinsonType.name.PD') },
      { index: 1, message: fm('diagnosis.parkinsonType.name.MSA') },
      { index: 2, message: fm('diagnosis.parkinsonType.name.MSA') },
      { index: 3, message: fm('diagnosis.parkinsonType.name.MSA') },
      { index: 4, message: fm('diagnosis.parkinsonType.name.PSP') },
      { index: 5, message: fm('diagnosis.parkinsonType.name.CBD') },
      { index: 6, message: fm('diagnosis.parkinsonType.name.CBD') },
      { index: 7, message: fm('diagnosis.parkinsonType.name.DLB') },
      { index: 8, message: fm('diagnosis.parkinsonType.name.DLB') },
      { index: 9, message: fm('diagnosis.parkinsonType.name.FTD') },
      { index: 10, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 11, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 12, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 13, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 14, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 15, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 16, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 17, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 18, message: fm('diagnosis.parkinsonType.opts.otherExtraPyramidalDisorders') },
      { index: 19, message: fm('diagnosis.parkinsonType.opts.alzheimer') },
      { index: 20, message: fm('diagnosis.parkinsonType.opts.earlyOnsetAlzheimer') },
      { index: 21, message: fm('diagnosis.parkinsonType.opts.lateOnsetAlzheimer') },
      { index: 22, message: fm('diagnosis.parkinsonType.opts.otherAlzheimer') },
      { index: 23, message: fm('diagnosis.parkinsonType.opts.unspecifiedAlzheimer') },
      {
        index: 24,
        message: fm('diagnosis.parkinsonType.opts.otherOrUnspecifiedCognitiveFunctionOrConsiousnessDisorder'),
      },
    ],
    style: { display: 'flex', justifyContent: 'center', width: '7rem' },
  },
  {
    name: 'diagnosisDate',
    type: 'Custom',
  },
  {
    name: 'medication',
    type: 'Custom',
  },
  {
    name: 'substance',
    type: 'Custom',
  },
  {
    name: 'currentLEDD',
    type: 'Custom',
  },
  {
    name: 'dbsTreatment',
    type: 'Checkbox',
    options: ['ongoing', 'ended'],
    optionFormatter: (name: string | number) => fm(`extendedSearch.opts.${name}`),
  },
  {
    name: 'thalamotomyOrHIFU',
    type: 'Checkbox',
    options: ['thalamotomyDone', 'hifuDone'],
    optionFormatter: (name: string | number) => fm(`extendedSearch.${name}`),
  },
  {
    name: 'currentHoehnYahr',
    type: 'MultiSelect',
    options: [0, 1, 1.5, 2, 2.5, 3, 4, 5],
    tooltips: [
      { index: 0, message: fm('updrs.opts.v.0') },
      { index: 1, message: fm('updrs.opts.v.1') },
      { index: 2, message: fm('updrs.opts.v.1.5') },
      { index: 3, message: fm('updrs.opts.v.2') },
      { index: 4, message: fm('updrs.opts.v.2.5') },
      { index: 5, message: fm('updrs.opts.v.3') },
      { index: 6, message: fm('updrs.opts.v.4') },
      { index: 7, message: fm('updrs.opts.v.5') },
    ],
    style: { display: 'flex', justifyContent: 'center', width: '2rem' },
  },
  {
    name: 'myServiceInUse',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'includeDeceased',
    type: 'Radio',
    options: ['yes', 'no'],
  },
];

export const defaultParkinsonSearchValues: TParkinsonESSearchFields = {
  currentLEDD: 'noCropping',
  dbsTreatment: 'noCropping',
  thalamotomyOrHIFU: 'noCropping',
  currentHoehnYahr: 'noCropping',
};
